import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InterpreterModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"interpreter_mode"}/>
}
